import ninjaApi from 'store/redux/apis/ninja.api';

export const googleAdsApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['NetworkAccount'],
  endpoints: (build) => ({
    /* Login facebook Account */
    connectGoogleAds: build.mutation({
      query: (data) => ({
        url: '/apps/google-ads/auth/connect',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['NetworkAccount'],
    }),
  }),
});

export const { useConnectGoogleAdsMutation } = googleAdsApi;
